import { Box } from '@/shared/ui';
import { SvgIcon } from '@/shared/ui/SvgIcon';

type TCheckIcon = { selected?: boolean };

export const CheckIcon = ({ selected }: TCheckIcon) => {
  return (
    <Box
      display="flex"
      gap={1}
      alignItems="center"
      justifyContent="center"
      width={24}
      height={24}
    >
      <SvgIcon
        name="check"
        style={{
          opacity: selected ? 1 : 0,
          transition: 'opacity 0.2s ease',
        }}
      />
    </Box>
  );
};
